<template>
    <div id="app">
        <router-view v-if="reloadFlag"/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                reloadFlag: true
            }
        },
        provide() {
            return {
                reload: this.reload
            }
        },
        methods: {
            // provide/inject 页面刷新方法
            reload() {
                this.reloadFlag = false;
                this.$nextTick().then(() => {
                    this.reloadFlag = true;
                })
            }
        }
    }
</script>

<style lang="scss">
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    a {
        text-decoration: none;
    }

    ul, li {
        list-style: none;
    }

    /*修改 placeholder 默认颜色*/
    input::-webkit-input-placeholder {
        color: #888 !important;
    }

    input::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #888 !important;
    }

    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #888 !important;
    }

    input:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #888 !important;
    }

    input, button {
        outline: none;
        border: none;
        background: transparent;
    }

    img {
        max-width: 100%;
    }

    #app {
        min-height: 100vh;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background: #F9F9F9;
    }
</style>
